import { flexPortalApi } from 'src/api';
import { AxiosRequestConfig } from 'axios';
import { ProductInfoResponse, UpdateProductInfoModel } from 'src/types';

export const getProductInfo = (config: AxiosRequestConfig = {}) =>
  flexPortalApi.get<ProductInfoResponse>('/api/v1/productInfo', config);

export const updateProductDescription = (data: UpdateProductInfoModel) =>
  flexPortalApi.patch<void>('/api/v1/productInfo', data);
